import { Button, ButtonProps } from '@mui/material';

export interface TextCancelButtonProps extends Omit<ButtonProps, 'onClick'> {
  /**
   * Mandatory callback function triggered when the user clicks the button to reset data.
   */
  handleCloseDialog: (e?: React.MouseEvent) => void;
  /**
   * Optional text text display inside the button.
   * @default "Annulla"
   */
  label?: string;
}

/**
 * A reusable, styled action button designed for close active table filters or form states.
 * Inherits all standard Material-UI Button properties except `onClick` (replaced by `handleCloseDialog`).
 *
 * @component
 */
export const TextCancelButton = ({
  handleCloseDialog,
  label = 'Annulla',
  sx,
  ...rest
}: TextCancelButtonProps) => {
  return (
    <Button
      {...rest}
      onClick={handleCloseDialog}
      color="inherit"
      variant="outlined"
      fullWidth
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 2.5,
        py: 1,
        borderColor: 'divider',
        '&:hover': {
          borderColor: 'text.secondary',
          bgcolor: 'action.hover'
        },
        ...sx
      }}>
      {label}
    </Button>
  );
};
